import { gql } from "@apollo/client";

export const VERIFY_CUSTOMER_LICENCE_DVLA = gql`
  query verifyLicenseWithDvla($customerId: String!, $licenseNumber: String!, $insuranceNumber: String!, $postCode: String!) {
    verifyLicenseWithDvla(customerId: $customerId, licenseNumber: $licenseNumber, insuranceNumber: $insuranceNumber, postCode: $postCode) {
      success
      message
    }
  }
`;